module.exports = __webpack_public_path__ + "img/galeria-especie-exotica-6.4eff9f05.jpg";